
import React, { useState, useEffect } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { Trans } from 'react-i18next';
const useStyles = makeStyles(styles);

const GerenciaAlertDesistir = () => { 

    const classes = useStyles();

    const [alert, setAlert] = useState({
        componente:(null),
        isToGiveUp: false,
        idToGiveUpSend: 0
    });
    const [confAlert, setConfAlert] = useState({
        statusAlert:0,
        idToGiveUpRecieve:0
    });
    /*
    statusAlert
    1 - showalert
    2 - hideAlert
    3 - sucess 
    */

    useEffect(() => {
        
      //console.log(confAlert);

      if (confAlert.statusAlert === 1) {
        showAlertGiveUp(confAlert.idToGiveUpRecieve);
    }
    else if (confAlert.statusAlert === 2) {
        hideAlertGiveUp();
    }
    else if (confAlert.statusAlert === 3) {
        successGiveUp();
    }
      
    }, [confAlert]);
  
    const confirmGiveUp = (id) =>{
        setAlert(
            {
                componente:null,
                isToGiveUp:true,
                idToGiveUpSend: id
            }
        );
      
    }

    const showAlertGiveUp = (id) => {
             
        setAlert(
            {
                componente:(<SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.giveup_campaign">
                                Tem certeza que deseja desisitir esse registro?
                            </Trans>}
                    onConfirm={() => confirmGiveUp(id)}
                    onCancel={() => setConfAlert({statusAlert:2})}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    cancelBtnCssClass={classes.button + " " + classes.danger}
                    confirmBtnText={<Trans i18nKey="information_message.confirm_giveup_campaign"> Sim, delete o registro! </Trans>}
                    cancelBtnText={<Trans i18nKey="button.cancel"> Cancelar </Trans>}
                    showCancel 
                    >
                        {<Trans i18nKey="information_message.giveup_campaign">
                            Tem certeza que deseja deletar esse registro?
                        </Trans>}                     
                    </SweetAlert>),
                isToGiveUp: false
            }
        );
    };

    const successGiveUp = () => {

        setAlert(
            {
                componente:(<SweetAlert
                    success
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.campaign_giveup"> Campanha Abandonada! </Trans>}
                    onConfirm={() => setConfAlert({statusAlert:2})}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    >
                    {<Trans i18nKey="information_message.success_giveup_campaign">
                        Campanha abandonada com sucesso.
                    </Trans>}                      
                    </SweetAlert>),
                isToGiveUp: false
            }
        );

    };
    
    const hideAlertGiveUp = () => {
        setAlert(
            {
                componente:(null),
                isToGiveUp: false,
                idToGiveUp: 0
            }
        );
    };
  
    return [alert, setConfAlert];
  };
  
  export {GerenciaAlertDesistir};